export default __webpack_public_path__ + "static/waxsettingandsilversetting-27e55bf2c97d637f10c3f7ec4ac5ec49.png";